import * as React from 'react';

const GuestGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h144v144H0z" />
            <g transform="translate(22 27)">
                <path
                    fill="#FFF"
                    d="M57.813 34.26c0 12.901-10.494 23.36-23.438 23.36-12.944 0-23.438-10.459-23.438-23.36 0-12.9 10.494-23.359 23.438-23.359 12.944 0 23.438 10.459 23.438 23.36"
                />
                <path
                    fill="#363A43"
                    d="M34.375 3.115c-17.231 0-31.25 13.972-31.25 31.146 0 17.173 14.019 31.145 31.25 31.145s31.25-13.972 31.25-31.145c0-17.174-14.019-31.146-31.25-31.146m0 65.406C15.42 68.521 0 53.152 0 34.261 0 15.369 15.42 0 34.375 0S68.75 15.369 68.75 34.26c0 18.892-15.42 34.261-34.375 34.261"
                />
                <path
                    fill="#F6682F"
                    d="M76.563 62.292C87.5 68.52 98.436 66.964 98.436 82.537v3.114h-68.75v-3.114c0-15.573 10.938-14.016 21.875-20.245h25z"
                />
                <path
                    fill="#FFF"
                    d="M70.313 68.521l-6.25-3.115-6.25 3.115-6.25-6.229 3.125-4.672h1.562v-6.229l7.813 1.557 7.812-1.557v6.229h1.563l3.125 4.672z"
                />
                <path
                    fill="#363A43"
                    d="M100 87.209H28.125v-4.672c0-12.474 6.945-15.106 14.3-17.892 2.723-1.03 5.538-2.096 8.363-3.705l1.55 2.704c-3.036 1.73-6.099 2.89-8.802 3.913-7.398 2.803-12.286 4.653-12.286 14.98v1.557h65.625v-1.557c0-10.327-4.888-12.177-12.286-14.98-2.703-1.023-5.766-2.183-8.802-3.913l1.55-2.704c2.825 1.609 5.64 2.676 8.363 3.705 7.355 2.786 14.3 5.418 14.3 17.892v4.672z"
                />
                <path
                    fill="#363A43"
                    d="M64.063 63.665l5.942 2.96 4.547-4.531-1.855-2.772-8.635 1.434-8.634-1.434-1.855 2.772 4.547 4.531 5.943-2.96zm6.557 6.75l-6.558-3.268-6.557 3.269-7.953-7.925 4.395-6.573 10.115 1.68 10.116-1.68 4.395 6.573-7.953 7.925z"
                />
                <mask id="guest-graphic_svg__a" fill="#fff">
                    <path d="M0 87.209h100V0H0z" />
                </mask>
                <path
                    fill="#363A43"
                    mask="url(#guest-graphic_svg__a)"
                    d="M70.313 57.62h3.125v-6.229h-3.125zM54.688 57.62h3.125v-6.229h-3.125zM62.5 80.979h3.125v-3.114H62.5zM62.5 74.75h3.125v-3.114H62.5z"
                />
                <path
                    fill="#FFF"
                    d="M78.125 31.146v6.23c-1.563 10.9-6.25 14.015-6.25 14.015-3.125 1.557-7.813 1.557-7.813 1.557s-4.687 0-7.812-1.557c0 0-4.688-3.115-6.25-14.016v-6.23l6.25-3.114 15.625 6.23 6.25-3.115z"
                    mask="url(#guest-graphic_svg__a)"
                />
                <path
                    fill="#F6682F"
                    d="M50 31.146c0-9.46 4.57-14.016 14.063-14.016 9.492 0 14.062 4.555 14.062 14.016l-6.25 3.115-7.813-3.115-7.812-3.115L50 31.146z"
                    mask="url(#guest-graphic_svg__a)"
                />
                <path
                    fill="#363A43"
                    d="M55.552 52.785l-.17-.099c-.213-.143-5.285-3.631-6.929-15.09l-.016-.22v-6.23h3.126v6.117c1.345 9.214 5 12.398 5.498 12.79 2.753 1.316 6.96 1.338 7.003 1.338.04 0 4.245-.022 6.997-1.338.489-.388 4.158-3.588 5.501-12.79v-6.117h3.126l-.016 6.45c-1.644 11.459-6.716 14.947-6.93 15.09l-.169.099c-3.415 1.7-8.304 1.72-8.51 1.72-.207 0-5.096-.02-8.511-1.72zm21.01-21.64c0-8.616-3.856-12.457-12.5-12.457-8.643 0-12.5 3.841-12.5 12.458h-3.124c0-10.334 5.256-15.573 15.624-15.573 10.37 0 15.626 5.239 15.626 15.573h-3.126z"
                    mask="url(#guest-graphic_svg__a)"
                />
                <path
                    fill="#363A43"
                    mask="url(#guest-graphic_svg__a)"
                    d="M71.947 35.966l-15.625-6.229-5.624 2.801-1.397-2.786 6.877-3.426 15.625 6.23 5.623-2.804 1.397 2.786zM45.795 32.965v3.071h-9.878v9.89h-3.083v-9.89h-9.878v-3.071h9.878v-9.891h3.083v9.891z"
                />
            </g>
        </g>
    </svg>
);

GuestGraphicSvg.displayName = 'GuestGraphicSvg';
export default GuestGraphicSvg;
